module.exports = __webpack_public_path__ + "registration-form-ca2d4608/energizer-8a21a7d8e3ec609336fc8b362b4119b2.jpeg";